import api from './api';

/**
 * سرویس احراز هویت
 * شامل ورود، ثبت‌نام و مدیریت کاربر
 */

// ورود کاربر
export const login = async (credentials) => {
  try {
    // credentials شامل phone، password و captchaInput
    const response = await api.post('/auth/login', credentials);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// ثبت‌نام کاربر جدید (فقط برای مدیران)
export const register = async (userData) => {
  try {
    const response = await api.post('/auth/register', userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getCaptcha = async () => {
  try {
    const response = await api.get('/auth/captcha', {
      responseType: 'text',          // مهم: متن خام برگردد، نه JSON
      withCredentials: true,        // ارسال کوکی session
    });
    const token = response.headers['x-captcha-token'];
    
    return {data:response.data,token};           // همان رشته SVG
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت اطلاعات کاربر فعلی
export const getCurrentUser = async () => {
  try {
    const response = await api.get('/auth/me');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// بروزرسانی پروفایل کاربر
export const updateProfile = async (profileData) => {
  try {
    const response = await api.put('/auth/update-profile', profileData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// تغییر رمز عبور
export const changePassword = async (passwordData) => {
  try {
    const response = await api.put('/auth/change-password', passwordData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// ارسال کد تایید برای بازیابی رمز عبور (با کپچا)
export const forgotPassword = async ({ phone, captchaInput, captchaToken }) => {
  try {
    const response = await api.post('/auth/forgot-password', {
      phone,
      captchaInput,
      captchaToken,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// ارسال مجدد کد تایید (با کپچا)
export const resendOTP = async ({ phone, captchaInput, captchaToken }) => {
  try {
    const response = await api.post('/auth/resend-otp', {
      phone,
      captchaInput,
      captchaToken,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// تایید کد OTP
export const verifyOTP = async (data) => {
  try {
    const response = await api.post('/auth/verify-otp', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// تغییر رمز عبور با کد تایید
export const resetPassword = async (resetData) => {
  try {
    const response = await api.post('/auth/reset-password', resetData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// خروج از سیستم
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.location.href = '/#/auth/signin';
}; 